/**
 * 「預設價格階數」的單一真相（客戶分級 × 該列成本來源 → 階數）。
 *
 * ── 為什麼在 需求 R151 抽出來
 * PM 2026-08-31 拍板 需求 R151 Q4=A：
 *   「Q4 「!」用哪一套判定：(A) 五個理由全部照算，只要有亮就顯示。」
 * 五個理由的第五個是「價格階非預設」＝ Number(item.priceTier) !== Number(rowDefaultTier)。
 * rowDefaultTier 不在 DB（Quote schema 沒有 defaultPriceTier 欄位），是前端用
 * getDefaultPriceTier(客戶 level, 該列 costSource) 現算的；在 需求 R151 之前這支函式是
 * QuoteCreatePage.js 與 QuoteEditPage.js **各一份的 page-local 函式**。
 * 產品詳細頁的「歷史報價」是第三個需要它的地方 —— 再複製一份就變成三份會各自演化的規則，
 * 直接違反 需求 R151 AC6「不新增第三套判定規則」。
 * ⇒ 本檔＝把兩頁那份逐字相同的實作抽成唯一一份，三處 import 同一個定義。
 *   （做法與 需求 R132 把 normalizeCostSource／calcTierPrice 抽進 quoteUnitPrice.js 相同；
 *    tests/quotePriceTierCostSource.fixture.js 的沙箱載入方式已同步改為從本檔抽宣告。）
 *
 * ── 規則本體（需求 R103 / 需求 R104 拍板，本檔只是搬家，值一律不動）
 *   分級   商品選「工廠」   商品選「經銷（任一）」
 *    A        2 階              1 階
 *    B        3 階              2 階
 *    C        4 階              3 階
 *    D        4 階              4 階
 *  要改階數規則請只改這裡；改完 tests/quotePriceTierCostSource.fixture.js 會逐格比對。
 */
import { normalizeCostSource } from './quoteUnitPrice';

export const TIER_MAP = {
  A: { factory: 2, distributor: 1 },
  B: { factory: 3, distributor: 2 },
  C: { factory: 4, distributor: 3 },
  D: { factory: 4, distributor: 4 },
};

// 需求 R103：預設階數＝客戶分級 × 該列成本來源。
// Q2=A：分級為空 / 未選客戶 / 非 A~D → 維持 1 階（不比照 A 級再分來源）。
// AC4：legacy 'distributor'（無索引）經 normalizeCostSource 轉成 distributor_0 後與
// distributor_1 同視為「經銷」。
export function getDefaultPriceTier(level, costSource) {
  const row = TIER_MAP[level];
  if (!row) return 1;
  const src = normalizeCostSource(costSource || 'factory');
  return src.startsWith('distributor') ? row.distributor : row.factory;
}
